// External
import { types } from 'mobx-state-tree';

// Locals
import models from './models';

const store = types.optional(
  types.model({
    /** The application store.models. */
    models: types.optional(types.model('ApplicationModels', models), {} as any),
  }),
  {}
);

const created = store.create({});

console.log('@clientCommon/bootstrapped store', created);

export default created;

export type StoreType = typeof created;
export type ModelsType = typeof created['models'];
